<script>
import DropZone from "@/components/widgets/dropZone2";
import _ from "lodash";
import {downloadFile, getFileDetail} from "@/service";
import {updateFiles} from "@/helpers/common-service";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  props: {
    // 接收文件ID或对象列表，进行预览
    value: {
      type: [Array, null, undefined],
      default () {
        return []
      }
    },
    // 选择文件时是否可多选
    multiple: {
      type: Boolean,
      default: true,
    },
    // 上传的文件前缀定义
    filenamePrefix: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    inputFileId: {
      type: String,
      default: "dropzoneFile",
    },
    // 是否显示预览列表
    showFileList: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changed"],
  data() {
    return {
      fileList: [],
      fileIds: [],
    };
  },
  computed: {

  },
  methods: {
    downloadFile,
    onFileSelected(files) {
      NProgress.start()
      const jobs = []
      for (let i = 0; i < files.length; i++) {
        jobs.push(updateFiles(files[i], 'add', this.filenamePrefix))
      }
      Promise.all(jobs).then(results => {
        for (let i = 0; i < results.length; i++) {
          this.fileList.push(results[i])
          this.fielIds.push(results[i].id)
        }
        this.$emit('changed', _.cloneDeep(this.fielIds))
        NProgress.done()
      })
    },
    // 初始化已有文件value，val可以是文件ID数组，也可以是文件对象数组
    initFileList(val) {
      const itemList = val ? val : []
      if (!itemList.length) {
        this.fielIds = []
        this.fileList = []
        return
      }
      // value 传的 图片对象
      if (typeof itemList[0] === 'object') {
        this.fielIds = _.map(itemList, 'id')
        this.fileList = itemList
        return;
      }
      // value 传的是图片ID
      this.fielIds = itemList
      this.fileList = []
      this.fielIds.forEach((attach) => {
        let pramas = {
          id__in: attach,
        };
        getFileDetail(pramas).then((res) => {
          if (res && res.payload && res.payload.results) {
            let results = res.payload.results;
            results.forEach((result) => {
              this.fileList.push(result);
            });
          }
        });
      });
    },
    drop(e) {
      const files = e.dataTransfer.files;
      this.onFileSelected(files)
    },
    selectedFile() {
      const files = document.querySelector("#" + this.inputFileId).files;
      this.onFileSelected(files)
    },
    deleteFile(index, id) {
      this.fileList.splice(index, 1)
      _.remove(this.fielIds, o => o == id)
      this.$emit('changed', _.cloneDeep(this.fielIds))
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.initFileList(val)
      }
    }
  },
  components: {
    DropZone,
  },
};
</script>
<template>
  <div>
    <label class="form-label">{{ title }}</label>
    <p class="text-muted">{{ description }}</p>
    <DropZone
      :input-file-id="inputFileId"
      :multiple="multiple"
      @drop.prevent="drop"
      @change="selectedFile"
    />
    <div v-if="showFileList">
      <div
        class="border rounded"
        v-for="(file, index) of fileList"
        :key="index"
      >
        <div class="d-flex align-items-center p-2">
          <div class="flex-grow-1">
            <div class="pt-1">
              <h5 class="fs-14 mb-1" data-dz-name="">
                {{ file.name }}
              </h5>
              <p class="fs-13 text-muted mb-0" data-dz-size="">
                <strong>{{ (file.size / 1024).toFixed(2) }}</strong> KB
              </p>
              <strong
                class="error text-danger"
                data-dz-errormessage=""
              ></strong>
            </div>
          </div>
          <div class="flex-shrink-0 ms-3">
            <b-button
              data-dz-remove=""
              variant="danger"
              size="sm"
              @click="deleteFile(index, file.id)"
            >
              {{ $t("base.delete") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
